<template>
  <div class="my-progress-container">
    <el-progress v-show="progress" class="my-progress" :text-inside="true" :stroke-width="14" :percentage="progress" />
    <svg v-show="progress!== 0 && progress!== 100" viewBox="25 25 50 50" class="circular"><circle cx="50" cy="50" r="20" fill="none" class="path" /></svg>
  </div>
</template>
<script>

export default {
  name: 'Progress',
  props: {
    progress: {
      type: Number,
      default: 0
    }
  },
  methods: {

  }
}
</script>
<style lang="scss" scoped>
.my-progress-container{
  display: flex;
}
.my-progress{
  flex: 1;
}
.circular {
  margin-left: 5px;
  height: 20px;
  width: 20px;
  animation: loading-rotate 2s linear infinite;
}
.path {
  animation: loading-dash 1.5s ease-in-out infinite;
  stroke-dasharray: 90,150;
  stroke-dashoffset: 0;
  stroke-width: 2;
  stroke: #0f68e0;
  stroke-linecap: round;
}
@keyframes loading-rotate {
  100%{
    transform: rotate(360deg);
  }
}
@keyframes loading-dash {
  0% {
    stroke-dasharray: 1,200;
    stroke-dashoffset: 0;
  }

  50% {
      stroke-dasharray: 90,150;
      stroke-dashoffset: -40px;
  }

  100% {
      stroke-dasharray: 90,150;
      stroke-dashoffset: -120px;
  }
}
</style>
